import { defineStore } from "pinia";
import api from "@/api/axios/axios.js";

// Rol reactivo cuya fuente de verdad es el backend (/login/roledash/).
// No se usa localStorage como fuente: se pide fresco al cargar.
export const useAuthStore = defineStore("auth", {
  state: () => ({
    user: null,
    role: null,
    loaded: false,
  }),
  getters: {
    isAdmin: (s) => s.role === "Admin QA",
    isManager: (s) => s.role === "Manager",
    isOwner: (s) => s.role === "Owner QA",
    isTester: (s) => s.role === "Tester QA",
    // Roles que ven el dashboard admin y pueden entrar a rutas adminOnly.
    canAdminAccess: (s) =>
      ["Admin QA", "Owner QA", "Manager"].includes(s.role),
  },
  actions: {
    async fetchRole() {
      const { data } = await api.get("/login/roledash/");
      this.user = data;
      this.role = data.role;
      this.loaded = true;
      return data;
    },
    // Trae el rol solo si aun no se ha cargado (util en guards de ruta).
    async ensureLoaded() {
      if (!this.loaded) await this.fetchRole();
      return this.role;
    },
    clear() {
      this.user = null;
      this.role = null;
      this.loaded = false;
    },
  },
});
